import { StoreModel } from '@/useCases/cart/types'

const getHeaderStore = (
  cartStore: StoreModel
): StoreModel | Record<string, never> => {
  try {
    if (cartStore?.id) {
      return cartStore
    }
    if (typeof window !== 'undefined') {
      const selectedStore = window.localStorage.getItem('selectedStore')
      if (selectedStore) {
        return JSON.parse(selectedStore)
      }
      return {}
    } else {
      return {}
    }
  } catch (error) {
    console.error('👹 ~ getHeaderStore ~ error:')
    return {}
  }
}

export default getHeaderStore
